
const boardRouter = [
    {
        path:'',
        name:'board-index',
        redirect: '/board/list'
    },{
        path:'list',
        name:'board-list',
        component: () => import(/* webpackChunkName: "about" */ '../views/board/list.vue'),
    }
]
export default boardRouter